import { useMemo } from 'preact/hooks'

export function FilterInputTabs({ values, onFilter, name, removeAll }) {
  function handleSelect(value) {
    if (!value) {
      removeAll(name)
      return
    }

    onFilter(value)
  }

  const isNoneSelected = useMemo(() => {
    return values.every((item) => !item.checked)
  }, [values])

  return (
    <div className="flex items-center p-1 rounded-full bg-primary-grey">
      <div className="flex items-center w-full basis-full">
        <input
          id={name + ':all'}
          type="checkbox"
          name={name}
          checked={isNoneSelected}
          onClick={() => handleSelect()}
          className="hidden field-checkbox peer"
        />
        <label
          for={name + ':all'}
          className="w-full px-4 py-2 font-medium text-center rounded-full paragraph-sm text-neturals-secondary-grey peer-checked:bg-primary-white"
        >
          All
        </label>
      </div>
      {values.map((item) => {
        return (
          <div className="flex items-center w-full basis-full" key={item.value}>
            <input
              id={item.value}
              type="checkbox"
              name={name}
              checked={item.checked}
              disabled={item.disabled}
              onClick={() => handleSelect(item.value)}
              className="hidden field-checkbox peer"
            />
            <label
              for={item.value}
              className="w-full px-4 py-2 font-medium text-center rounded-full paragraph-sm text-neturals-secondary-grey peer-checked:bg-primary-white"
            >
              {item.label}
            </label>
          </div>
        )
      })}
    </div>
  )
}
